<template>
  <div class="modal_wrapper" :style="{backgroundColor: backgroundColor}">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          <img :src="info" height="25px" />
          {{ title }}
        </div>
        <div class="modal_body">
          <div class="body">
            <inputSection
              :titleLabel="mailTitle"
              @inputUpdate="inputUpdateMail('mailTitle')"
            ></inputSection>
            <textAreaSection
              :titleLabel="mailContent"
              @inputUpdate="inputUpdateMail('mailContent')"
            ></textAreaSection>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              type="button"
              :value="okButton"
              class="finish_button"
              @click="showConfirmModal = true"
            />
          </div>
          <div class="modal_window" v-if="showConfirmModal">
            <confirmModalWindow
              :question="confirmWord"
              @close="stayClose"
              @ok="sendMail"
            >
            </confirmModalWindow>
          </div>
          <div class="complete_modal_window" v-if="showCompleteModal">
            <finishModalWindow :question="completeWord" @close="close">
            </finishModalWindow>
          </div>
          <div class="modal_window" v-if="showFailureModal">
            <finishModalWindow :question="failureWord" @close="stayClose">
            </finishModalWindow>
          </div>
          <div class="loading_modal_window" v-if="showloadingModal">
            <loadingModalWindow @close="close"> </loadingModalWindow>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inputSection from './modalwindowComponents/inputSection.vue'
import textAreaSection from './modalwindowComponents/textAreaSection.vue'
import confirmModalWindow from './confirmModalWindow.vue'
import finishModalWindow from './finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  props: ['type', 'tenantKey'],
  data() {
    return {
      info: require('../../../../img/mail.png'),
      title: 'メール送信',
      mailTitle: '件名:',
      mailContent: '内容:',
      cancelButton: 'キャンセル',
      okButton: '送信',
      completeWord: '',
      failureWord: '',
      confirmWord: 'この内容でメールを送信しますか？',
      showConfirmModal: false,
      showCompleteModal: false,
      showFailureModal: false,
      showloadingModal: false,
      errorMessage: '',
    }
  },
  components: {
    inputSection,
    textAreaSection,
    confirmModalWindow,
    finishModalWindow,
    loadingModalWindow
  },
  computed: {
    backgroundColor() {
      if (
        this.showCompleteModal === true ||
        this.showConfirmModal === true ||
        this.showFailureModal === true
      ) {
        return ''
      } else {
        return 'rgba(0, 0, 0, .5)'
      }
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    }
  },
  created() {
    this.$store.dispatch('corporationsCommonOption/cleareMailInfo')
  },
  methods: {
    close(e) {
      this.$emit('close')
    },
    stayClose(e) {
      this.showFailureModal = false
      this.showConfirmModal = false
    },
    inputUpdateMail(e) {
      this.$store.dispatch('corporationsCommonOption/inputUpdateMail', {
        name: e,
        value: event.target.value
      })
    },
    async sendMail() {
      this.showloadingModal = true
      this.showConfirmModal = false
      this.errorMessage = ''
      try {
        await this.$store.dispatch('corporationsCommonOption/sendMail', {
          type: this.type,
          tenantKey: this.tenantKey ? this.tenantKey : null
        })
        this.completeWord =
          'メール送信を受け付けました。<br/>順次送信処理を行います。<br/>送信結果は、しばらくしてからメール送信履歴にてご確認ください。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber =
          this.$store.state.error.sysErrorCode.sysErrorCode_610001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0074')
        if (this.errorMessage === 'MSGCRD0122') {
          this.showCompleteModal = true
        } else {
          this.showFailureModal = true
        }
      }
      this.showloadingModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        this.errorMessage = error.response.data.header.message
        // 一部成功の場合はメールダイアログを閉じる
        if (this.errorMessage === 'MSGCRD0122') {
          this.completeWord =
            this.sysErrorMsg[this.errorMessage].name +
            this.sysErrorMsg[this.errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else if (this.sysErrorMsg[this.errorMessage]) {
          this.failureWord =
            this.sysErrorMsg[this.errorMessage].name +
            this.sysErrorMsg[this.errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else if (error.response && error.response.data) {
        this.failureWord =
          this.sysErrorMsg[errorNumber].name +
          this.sysErrorMsg[errorNumber].value +
          'エラーコード：{' +
          eventNumber +
          '}'
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    }
  }
}
</script>
<style scoped>
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  height: 391px;
  padding-top: 40px;
}
.modal_container {
  height: 485px;
}
.modal_header {
  background-color: #33ccff;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/modalWindow/mailSendModalWindow.vue